// Phase 11a — Payout read shapes. Header-level fields per the
// 11-5 schema sketch + 11a-3/4/5/7 locks.
import { z } from 'zod';
import { PayoutMechanicSchema, PayoutStatusSchema } from './enums.schema.js';
export const PayoutResponseSchema = z.object({
    id: z.string().uuid(),
    payoutNumber: z.string().nullable(),
    caregiverId: z.string().uuid(),
    cycleStartDate: z.string().date(),
    cycleEndDate: z.string().date(),
    status: PayoutStatusSchema,
    subtotalCents: z.number().int().nonnegative(),
    hstCents: z.number().int().nonnegative(),
    totalCents: z.number().int().nonnegative(),
    hstRegistrantAtIssue: z.boolean(),
    hstNumberAtIssue: z.string().nullable(),
    mechanic: PayoutMechanicSchema.nullable(),
    externalRef: z.string().nullable(),
    issuedAt: z.string().datetime().nullable(),
    holdUntil: z.string().datetime().nullable(),
    paidAt: z.string().datetime().nullable(),
    voidedAt: z.string().datetime().nullable(),
    voidReason: z.string().nullable(),
    statementPdfKey: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=payout.schema.js.map